<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path:'/home_page/home_Page' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: '/user_mn/User_mn' }"
        >个人中心</el-breadcrumb-item
      >
      <el-breadcrumb-item>修改密码</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 修改密码 -->
    <div  style="margin-top: 20px; heigth: 1000px; width:30%; border:1px solid #f5f5f5; box-shadow: 10px 10px  10px #f5f5f5;">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <h3 class="title_style">修改密码</h3>
          <el-form-item label="原密码" prop="password">
            <el-input
              type="password"
              v-model="ruleForm.password"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="new_password">
            <el-input
              type="password"
              v-model="ruleForm.new_password"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >提交</el-button
            >
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
    </div>
  </div>
</template>
<script>
import { get_user_reset_password } from "../../api/user/user";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.new_password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        password: "",
        new_password: "",
        checkPass: "",
      },
      rules: {
        password: [
          { required: true, message: "请输入原密码", trigger: "blur" },
        ],
        new_password: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          get_user_reset_password(this.ruleForm).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              this.ruleForm = {};
              setTimeout(() => {
                this.$store.commit("logout", "false");
                this.$router.push({ path: "/login" });
              }, 1000);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style>
.title_style {
  text-align: center;
}
.demo-ruleForm{
  margin-right: 30px;

}
</style>


// WEBPACK FOOTER //
// src/views/user_mn/User_pwd.vue